import { performCatalogSearch } from 'app/actions/SearchActions';
import {
  BROWSE_TITLES_PAGE_FACET_FIELD_IDS,
  SUB_PAGE_BASE_API_PARAMS,
  SUB_PAGE_SLUG
} from 'app/constants/BrowseConstants';
import { mapQueryStateToCatalogSearchParams } from 'app/helpers/browse';
import { deserializeQuerystring } from 'app/helpers/browse/browseQueryHelpers';
import connectRoute from 'app/routes/connectRoute';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';

const BrowseTitlesOnOrderPageRoute = () => null;

const getRouteData = ({ dispatch, location, state }) => {
  const includedFieldIds = BROWSE_TITLES_PAGE_FACET_FIELD_IDS;
  const searchParams = new URLSearchParams(location.search);
  const searchScopes = selectCurrentSiteScopes(state)?.toJS() ?? [];

  const catalogSearchFilters = mapQueryStateToCatalogSearchParams(
    deserializeQuerystring(searchParams, {
      includedFieldIds,
      searchScopes
    }),
    { includedFieldIds }
  );

  return [
    dispatch(
      performCatalogSearch(
        {
          ...SUB_PAGE_BASE_API_PARAMS[SUB_PAGE_SLUG.ON_ORDER],
          ...catalogSearchFilters
        },
        { isPersistShowMoreFiltersFieldId: true }
      )
    )
  ];
};

export default connectRoute(BrowseTitlesOnOrderPageRoute, {
  debounceOptions: {
    wait: 500 // milliseconds
  },
  getRouteData
});
